// Fetch models for all clients

import { handleAPIError } from "@services/Base";
import { useQueries } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";
import { ClientModel } from "../types";

export const useClientsModels = (clientIds?: string[]) => {
  return useQueries({
    queries: (clientIds || []).map((clientId) => ({
      queryKey: ["client", clientId, "models"],
      enabled: !!clientId,
      queryFn: ({ signal }: { signal: AbortSignal }) =>
        axios
          .get(
            `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/${clientId}/models`,
            { signal }
          )
          .then((response) => response.data as ClientModel[])
          .catch((error) => handleAPIError(error))
    }))
  });
};
